import { Link } from "react-router-dom";
import walletClosedIcon from "../../assets/img/wallet-close.webp";
import walletOpenIcon from "../../assets/img/wallet-open.webp";
import logo from "../../assets/img/logo.webp";

const AccessDAppLink: React.FC = () => {
  return (
    <>
      <Link
        to="/dApp"
        aria-label="Access dApp dashboard"
        className="relative flex items-center group"
      >
        <img
          src={walletClosedIcon}
          alt="Closed wallet icon"
          className="w-8 h-8 transition-all duration-500 ease-in-out group-hover:opacity-0 group-hover:scale-110"
        />
        <img
          src={walletOpenIcon}
          alt="Open wallet icon"
          className="absolute w-8 h-8 opacity-0 group-hover:opacity-100 scale-110 rotate-6 transition-all duration-500 ease-in-out"
        />
        <p className="ml-1 text-base sm:text-lg font-extrabold text-red-200 relative group-hover:text-[var(--color-primary)] transition-colors duration-300 after:absolute after:bottom-[-4px] after:left-0 after:w-0 group-hover:after:w-full after:h-[2px] after:bg-[var(--color-primary)] after:transition-all after:duration-500 after:ease-in-out">
          MyDApp
        </p>
      </Link>
      <Link to="/">
        <div className="flex items-center ml-7 gap-2">
          <img
            src={logo}
            alt="UcWaves Logo"
            className="h-10 w-auto hidden sm:block"
          />
        </div>
      </Link>
    </>
  );
};

export default AccessDAppLink;
